/* A dot cursor for the whole site, after offmenu.design's.

   A 10 px white dot in difference mode (so it reads black on light areas and
   white on dark ones) follows the pointer with easing: position eases 35%
   of the way per frame, size 12%, so it trails slightly and swells softly.
   Over links and buttons it grows to a 34 px disc; elements can set their
   own size with data-cursor-hover="64". Pressing shrinks it to
   90%. Text fields keep the native text cursor and hide the dot. So does
   anything marked data-cursor-hide, such as the box around the Cal.com
   booker: inside an embedded frame the page receives no pointer moves, so
   a visible dot would freeze at the frame's edge.

   It only runs for a fine pointer (a mouse or trackpad) on screens at least
   640 px wide; touch devices keep their default behavior. */

const DOT = 10;
const HOVER = 34;
const INTERACTIVE = "a, button, summary, label, select, [role='button'], [data-cursor-hover]";
const TEXT_FIELD = "input:not([type='button']):not([type='submit']):not([type='checkbox']):not([type='radio']), textarea, [contenteditable='true']";

let started = false;

function lerp(from, to, amount) {
  return from + (to - from) * amount;
}

export function startDotCursor() {
  if (started || typeof window === "undefined") return;
  const fine = window.matchMedia("(pointer: fine)");
  if (!fine.matches || window.innerWidth < 640) return;
  started = true;

  const root = document.documentElement;
  const dot = document.createElement("div");
  dot.className = "dot-cursor";
  dot.setAttribute("aria-hidden", "true");
  document.body.appendChild(dot);
  root.classList.add("has-dot-cursor");

  const target = { x: window.innerWidth / 2, y: window.innerHeight / 2, size: DOT, opacity: 0, press: 1 };
  const current = { ...target };
  let seen = false;

  window.addEventListener(
    "mousemove",
    (event) => {
      target.x = event.clientX;
      target.y = event.clientY;
      if (!seen) {
        // Appear where the pointer is, instead of gliding in from the middle.
        seen = true;
        current.x = target.x;
        current.y = target.y;
      }
      const element = event.target instanceof Element ? event.target : null;
      if (element?.closest(TEXT_FIELD) || element?.closest("[data-cursor-hide]")) {
        target.opacity = 0;
        return;
      }
      target.opacity = 1;
      const custom = element?.closest("[data-cursor-hover]");
      if (custom) target.size = Number(custom.getAttribute("data-cursor-hover")) || HOVER;
      else target.size = element?.closest(INTERACTIVE) ? HOVER : DOT;
    },
    { passive: true }
  );
  // Entering a frame shows up only as leaving the element around it.
  document.addEventListener("mouseout", (event) => {
    if (event.relatedTarget instanceof HTMLIFrameElement) target.opacity = 0;
  });
  document.addEventListener("mouseleave", () => {
    target.opacity = 0;
  });
  document.addEventListener("mouseenter", () => {
    if (seen) target.opacity = 1;
  });
  window.addEventListener("mousedown", () => {
    target.press = 0.9;
  });
  window.addEventListener("mouseup", () => {
    target.press = 1;
  });

  const tick = () => {
    current.x = lerp(current.x, target.x, 0.35);
    current.y = lerp(current.y, target.y, 0.35);
    current.size = lerp(current.size, target.size, 0.12);
    current.press = lerp(current.press, target.press, 0.2);
    current.opacity = lerp(current.opacity, target.opacity, 0.15);
    const size = current.size * current.press;
    dot.style.transform = `translate3d(${current.x - size / 2}px, ${current.y - size / 2}px, 0)`;
    dot.style.width = `${size}px`;
    dot.style.height = `${size}px`;
    dot.style.opacity = current.opacity.toFixed(3);
    requestAnimationFrame(tick);
  };
  requestAnimationFrame(tick);
}
